import { CONTENT_DEFAULT_BRANCH } from '../types';

export const CONTENT_BRANCH_PREFIX_SEPARATOR = ':';

/**
 * Prefixes a ContentBranch identifier with the given prefix, except `main`.
 * Throws an error if branchId is the CONTENT_DEFAULT_BRANCH alias.
 */
export function formatBranchId(prefix: string, branchId: string): string {
    if (branchId === CONTENT_DEFAULT_BRANCH) {
        throw new Error(`Cannot format ${CONTENT_DEFAULT_BRANCH} branch id`);
    }

    return `${prefix}${CONTENT_BRANCH_PREFIX_SEPARATOR}${branchId}`;
}

/**
 * Removes the given acceptPrefix from a prefixed branch identifier.
 * Throws an error if branchId is not prefixed with prefix.
 */
export function unformatBranchIdOrThrow(branchId: string, acceptPrefix: string): string {
    if (!branchId.startsWith(`${acceptPrefix}:`)) {
        throw new Error(`Branch ${branchId} is not prefixed with ${acceptPrefix}`);
    }

    return branchId.substring(acceptPrefix.length + 1);
}
